import { Component, EventEmitter, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TextButtonComponent } from '../../../../../shared/components/text-button/text-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-help-card',
  imports: [MatIcon, TextButtonComponent, TranslocoPipe],
  templateUrl: './help-card.component.html',
})
export class HelpCardComponent {
  @Output() supportButtonClick: EventEmitter<void> = new EventEmitter<void>();

  onSupportButtonClick() {
    this.supportButtonClick.emit();
  }
}
